import { Group } from '@esg/esg-global-types';
import { createContext } from 'react';

interface ContextProps {
  group: Group | null;
  handleGroupChange: (group: Group | null) => void;
}

export const GroupContext = createContext<ContextProps>({
  group: null,
  handleGroupChange: () => null
});
